export default "__VITE_ASSET__gbX74rqB__"